import type { CappsLandlordPropertyCreateWebApiHandler_create_Options } from '@zg-rentals/ts-capps-client-react-query';
import { useCappsLandlordPropertyCreateWebApiHandler_create } from '@zg-rentals/ts-capps-client-react-query';
import { PROPERTIES_QUERY_TAG } from './useGetProperties';
import type { ListingType, PropertyType } from '@zg-rentals/ts-capps-client';

export interface CreatePropertyRequest {
  listingType: ListingType;
  fullAddress: string;
  propertyType: PropertyType;
  unitNumber?: string;
}

export interface CreatePropertyResponse {
  listingAlias: string;
  duplicateListingAlias?: string;
}

export function useCreateProperty(options?: CappsLandlordPropertyCreateWebApiHandler_create_Options) {
  return useCappsLandlordPropertyCreateWebApiHandler_create({
    ...options,
    meta: { invalidates: [PROPERTIES_QUERY_TAG] },
  });
}
